import React from 'react'
import {booking} from '@whyhotel/common-schema'
import clsx from 'clsx'
import {formatCurrency} from '../../services/utils'
import {formatDisplayDate, toLocalDateTime} from '../../services/dateUtils'

export interface ShoppingCartPaymentInstallmentProps {
  paymentInstallment: booking.PaymentInstallment
  className?: string
  isLast: boolean
}

const ShoppingCartPaymentInstallment = ({
  paymentInstallment,
  className,
  isLast
}: ShoppingCartPaymentInstallmentProps) => {
  const nights = paymentInstallment.nights
  const dueDate = paymentInstallment.dueDate
    ? formatDisplayDate(toLocalDateTime(paymentInstallment.dueDate))
    : ''
  const isPrepayment = ['TransientPrepayment', 'MonthlyPrepayment'].includes(
    paymentInstallment.type
  )

  return (
    <div
      className={clsx(
        'border-2 rounded-xl flex flex-row items-center gap-2 p-4',
        {
          'border-accent': isPrepayment
        },
        className
      )}
    >
      {paymentInstallment.type === 'TransientPrepayment' && (
        <div className="flex-1">
          <div className="font-semibold text-md">Due Now</div>
          <div className="text-sm">Pay now for the full cost of your stay.</div>
        </div>
      )}
      {paymentInstallment.type === 'TransientPayAtStay' && (
        <div className="flex-1">
          <div className="font-semibold text-md">Due Later</div>
          <div className="text-sm">
            Your credit card will be charged one day before check-in.
          </div>
        </div>
      )}
      {paymentInstallment.type === 'MonthlyPrepayment' && (
        <div className="flex-1">
          <div className="font-semibold text-md">Due Now</div>
          <div className="text-sm">
            Pay for the first {nights === 1 ? `night` : `${nights} nights`} to
            guarantee your stay.
          </div>
        </div>
      )}
      {paymentInstallment.type === 'MonthlyInstallment' && (
        <div className="flex-1">
          <div className="font-semibold text-md">Due {dueDate}</div>
          <div className="text-sm">
            Pay for the {isLast ? 'last' : 'next'}{' '}
            {nights === 1 ? 'night' : `${nights} nights`} of your stay.
          </div>
        </div>
      )}
      <div
        className={clsx('flex-none', {
          'font-bold': isPrepayment,
          'font-medium': !isPrepayment
        })}
      >
        {formatCurrency(paymentInstallment.amount)}
      </div>
    </div>
  )
}

export default ShoppingCartPaymentInstallment
